module.exports = __webpack_public_path__ + "static/images/trackBooking.3Piry2r.svg";